<template>
  <transition name="modal">
    <div v-if="isShowModal" class="modal-backdrop">
      <div class="modal-backdrop__inner">
        <!-- 閉じるボタン -->
        <div class="modal-backdrop__close">
          <button @click="close" class="modal-backdrop__close--btn">
            <Icon name="action_close" :color="'#ffff'" />
          </button>
        </div>

        <!-- モーダルボディ -->
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data: () => ({
    isShowModal: false
  }),

  methods: {
    showModal() {
      // this.$modal.inert = true;
      // スクロール固定
      document.body.style.overflow = "hidden";
      this.isShowModal = true
    },

    close() {
      this.isShowModal = false
      // this.$modal.inert = false;
      document.body.style.overflow = "";
    }
  }
};
</script>

<style scoped lang="scss">
.modal-enter-active,
.modal-leave-active .modal-enter,
.modal-leave-to {
  transition: opacity ease 0.2s;
}

.modal-enter-active,
.modal-leave-active {
  opacity: 1;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.modal-backdrop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  inset: 0;
  z-index: 1500;
  overflow-y: hidden;
  background-color: rgba($color: #1f2021, $alpha: 0.64);
}

.modal-backdrop__inner {
  $pc-close-h: 5vh;
  $sp-close-h: 3vh;

  transform: translateY(-$pc-close-h);

  @include mq() {
    transform: translateY(-$sp-close-h);
  }

  .modal-backdrop__close {
    display: flex;
    justify-content: end;
    height: $pc-close-h;

    @include mq() {
      height: $sp-close-h;
    }
  }
}

.modal-backdrop__close--btn {
  background-color: transparent;
  cursor: pointer;

  & > svg {
    width: 30px;
    height: 30px;
  }

  @include mq() {
    & > svg {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
